import { ReduxUtils } from '../../../dependencies';
import { types } from '../../actions';

const actionTypes = {
    REQUEST: types.FETCH_EXPENSE_TRIGGER_REQUEST,
    SUCCESS: types.FETCH_EXPENSE_TRIGGER_SUCCESS,
    FAILURE: types.FETCH_EXPENSE_TRIGGER_FAILURE,
    CANCEL: types.FETCH_EXPENSE_TRIGGER_CANCEL,
};

const basicReducer = ReduxUtils.basicApiReducer({
    actionTypes,
});

export default ReduxUtils.containerReducer({
    childReducer: basicReducer,
    actionTypes: Object.values(actionTypes),
    selectors: {
        itemId: action => action.meta.id,
    },
});
